import { Badge, Tooltip } from "@mui/material";

// useTheme

import { useTranslation } from "next-i18next";
// import { useSelector } from "react-redux";
// NOVU_BACKENDURL, NOVU_SOCKETURL,
// import { NOVU_APPLICATIONIDENTIFIER, NOVU_SUBSCRIBER_ID } from "@/configs";
// import { User } from "@/models/user";
// import { rootReducerName } from "@/store/rootReducer";
// import { alpha } from "@mui/material";
// import { NotificationBell, NovuProvider, PopoverNotificationCenter } from "@novu/notification-center";
import styled from "styled-components";

const NotificationsBadge = styled(Badge)(
  ({ theme }) => `

    .MuiBadge-badge {
        min-width: 16px;
        height: 16px;
        padding: 0;
        color: ${theme?.palette?.common.white ?? "#fff"};
        background-color: ${theme?.palette?.error.main ?? "#d32f2f"};

        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;

            content: "";
        }
    }
`
);

function HeaderNotifications() {
  const { t } = useTranslation();
  // const user: User = useSelector((state) => state[rootReducerName.auth].user);
  // incase NOVU_SUBSCRIBER_ID for testing use that or user id is subscriber id

  // const subscriberId = NOVU_SUBSCRIBER_ID ? NOVU_SUBSCRIBER_ID : user.id;
  // const theme = useTheme();

  // const subscriberId = NOVU_SUBSCRIBER_ID ? NOVU_SUBSCRIBER_ID : user.id;

  return (
    <>
      <Tooltip arrow title={t("Notifications")}>
        <NotificationsBadge
          anchorOrigin={{
            vertical: "top",
            horizontal: "right"
          }}
        >
          {/* <NovuProvider
            // test with own novu server,  https://docs.novu.co/notification-center/client/react/api-reference
            // backendUrl={NOVU_BACKENDURL}
            // socketUrl={NOVU_SOCKETURL}
            subscriberId={subscriberId}
            applicationIdentifier={NOVU_APPLICATIONIDENTIFIER}
          >
            <PopoverNotificationCenter colorScheme={theme.palette.mode === "dark" ? "dark" : "light"}>
              {({ unseenCount }) => <NotificationBell unseenCount={unseenCount} />}
            </PopoverNotificationCenter>
          </NovuProvider> */}
        </NotificationsBadge>
      </Tooltip>
    </>
  );
}

export default HeaderNotifications;
